import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const OperationsFormSectionLabel = styled.div`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary};
  margin-top: 30px;
`;

export const OperationsCheckboxContainer = styled.div`
  border-radius: 8px;
  align-items: center;
  display: flex;
`;

export const OperationsCheckboxField = styled.div`
  cursor: pointer;
  width: 25px;
  height: 25px;
  border-radius: 4px;
  border: 1.5px solid ${colors.textHyperlink};
  background: ${prop => prop.checked ? colors.textHyperlink : colors.white};
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  &[disabled] {
    background: ${colors.readOnlyBorder};
    border: 1px solid ${colors.readOnlyBorder};

    svg {
      color: ${colors.readOnlyBorder} !important;
    }
  }
`;

export const OperationsCheckboxLabel = styled.h6`
  color: ${colors.textPrimary};
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
`;
